var _defs, _polygon, _polygon2, _polygon3, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _polygon4, _path7, _path8, _path9, _polygon5, _path10, _polygon6, _polygon7, _rect5, _rect6, _path11, _polygon8, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _ellipse, _ellipse2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1104",
    width: 360,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1106"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 500 500",
    viewBox: "0 0 500 500",
    width: 360,
    height: 360,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#aebef9",
    points: "340.73 101.27 340.33 87.88 335.7 87.99 339.3 73.54 343.97 73.3 341.25 82.54 345.83 82.03",
    className: "coloraebef9 svgShape"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#aebef9",
    points: "357.55 103.24 366.13 92.95 362.59 89.96 374.86 81.53 378.51 84.44 370.35 89.56 374.13 92.21",
    className: "coloraebef9 svgShape"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#aebef9",
    points: "373.43 114.3 385.69 108.91 383.85 104.66 398.59 102.58 400.56 106.82 390.98 107.76 393.18 111.82",
    className: "coloraebef9 svgShape"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#d6e0fa",
    d: "M277.1,97.85H166.44c-2.94,0-5.32,2.37-5.32,5.32v154.45c0,2.93,2.37,5.32,5.32,5.32H277.1 c2.93,0,5.32-2.39,5.32-5.32V103.17C282.42,100.22,280.04,97.85,277.1,97.85z M281.5,257.61c0,2.42-1.98,4.4-4.4,4.4H166.44 c-2.43,0-4.41-1.98-4.41-4.4V103.17c0-2.43,1.98-4.4,4.41-4.4H277.1c2.42,0,4.4,1.97,4.4,4.4V257.61z",
    className: "colord6e0fa svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6e0fa",
    d: "M277.1,97.85H166.44c-2.94,0-5.32,2.37-5.32,5.32v15.24h121.3v-15.24 C282.42,100.22,280.04,97.85,277.1,97.85z M241.26,110.66c-1.4,0-2.54-1.14-2.54-2.54c0-1.41,1.14-2.55,2.54-2.55 c1.41,0,2.55,1.14,2.55,2.55C243.81,109.52,242.67,110.66,241.26,110.66z M254.84,110.66c-1.4,0-2.54-1.14-2.54-2.54 c0-1.41,1.14-2.55,2.54-2.55c1.41,0,2.55,1.14,2.55,2.55C257.39,109.52,256.25,110.66,254.84,110.66z M268.43,110.66 c-1.41,0-2.55-1.14-2.55-2.54c0-1.41,1.14-2.55,2.55-2.55c1.4,0,2.54,1.14,2.54,2.55 C270.97,109.52,269.83,110.66,268.43,110.66z",
    className: "colord6e0fa svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 74.51,
    height: 3.88,
    x: 184.51,
    y: 138.96,
    fill: "#d6e0fa",
    className: "colord6e0fa svgShape"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 74.51,
    height: 3.88,
    x: 184.51,
    y: 155.28,
    fill: "#d6e0fa",
    className: "colord6e0fa svgShape"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 74.51,
    height: 3.88,
    x: 184.51,
    y: 171.61,
    fill: "#d6e0fa",
    className: "colord6e0fa svgShape"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 11.14,
    height: 196.55,
    x: 155.59,
    y: 228.1,
    fill: "#263156",
    className: "color263156 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#de5469",
    d: "M154.45,122.73l-57.01,98.74c-2.98,5.16,0.74,11.61,6.7,11.61h114.02c5.96,0,9.68-6.45,6.7-11.61 l-57.01-98.74C164.88,117.57,157.43,117.57,154.45,122.73z",
    className: "colorde5469 svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M211.29,225.19H111.02c-1.44,0-2.72-0.74-3.44-1.99c-0.72-1.24-0.72-2.73,0-3.98l50.63-87.7 c0.62-1.07,1.72-1.7,2.95-1.7c0,0,0,0,0,0c1.23,0,2.33,0.64,2.95,1.7l50.63,87.7c0.72,1.24,0.72,2.73,0,3.98 C214.02,224.45,212.73,225.19,211.29,225.19z M158.8,131.87l0.59,0.34l-50.63,87.7c-0.47,0.82-0.47,1.79,0,2.61 c0.47,0.82,1.32,1.3,2.26,1.3h100.27c0.94,0,1.79-0.49,2.26-1.3c0.47-0.82,0.47-1.79,0-2.61l-50.63-87.7 c-0.37-0.64-1.03-1.02-1.76-1.02c-0.74,0-1.39,0.38-1.76,1.02L158.8,131.87z",
    className: "colorfff svgShape"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M160.38,213.48c-3.99,0-6.66-2.68-6.66-6.01c0-3.46,2.68-6.14,6.66-6.14c3.92,0,6.6,2.68,6.6,6.14 C166.98,210.8,164.3,213.48,160.38,213.48z M154.17,165.45h12.09l-1.31,31.3h-9.48L154.17,165.45z",
    className: "colorfff svgShape"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#46ceff",
    d: "M187.16,403.94c0,0-2.97,7.61,6.12,10.44c9.09,2.82,15.71,3.66,20.72,3.59c5.01-0.07,8.01-1.02,12.96,0.42 c4.96,1.45,9.69,4.59,12.74,2.55c2.5-1.68,1.78-7.81,1.78-7.81l-27.82-5.52L187.16,403.94z",
    className: "color6f52e7 svgShape"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecc351",
    points: "242.19 396.07 248.86 377.27 226.36 369.29 219.99 392.98 223.95 401.01 236.16 402.78",
    className: "colorecc351 svgShape"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M219.99,392.98c0,0-12.62,5.61-18.59,7.18c-5.97,1.57-12.63-1.72-14.25,3.78s13.93,7.38,23.06,8.38 c9.13,1,16.12-1.22,20.53,1.12c4.41,2.34,10.08,1.17,10.73-0.31c0.65-1.48,1.64-15.52,0.71-17.06c0,0-1.68,2.53-10.56,0.96 C222.77,395.47,219.99,392.98,219.99,392.98z",
    className: "color263156 svgShape"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M207.41 402.25l-.15.05c-.29.1-.6-.05-.7-.34l-1.1-3.19c-.1-.29.05-.61.34-.71l.15-.05c.29-.1.6.05.7.34l1.1 3.19C207.85 401.83 207.7 402.15 207.41 402.25zM210.28 400.99l-.15.05c-.29.1-.6-.05-.7-.34l-1.1-3.19c-.1-.29.05-.61.34-.71l.15-.05c.29-.1.6.05.7.34l1.1 3.19C210.72 400.57 210.56 400.89 210.28 400.99zM213.57 399.7l-.15.05c-.29.1-.6-.05-.7-.34l-1.1-3.19c-.1-.29.05-.61.34-.71l.15-.05c.29-.1.6.05.7.34l1.1 3.19C214.01 399.29 213.86 399.6 213.57 399.7zM216.83 398.43l-.15.05c-.29.1-.6-.05-.7-.34l-1.1-3.19c-.1-.29.05-.61.34-.71l.15-.05c.29-.1.6.05.7.34l1.1 3.19C217.27 398.01 217.12 398.33 216.83 398.43z",
    className: "colorfff svgShape"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M322.75,272.34c0,0-53.98,5.5-70.47,16.49s-22.38,61.23-29.38,88.72l30.46,7.75c0,0,13.41-41.5,19.41-59.99 c6-18.49,77.97-26.49,77.97-26.49L322.75,272.34z",
    className: "color263156 svgShape"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#46ceff",
    points: "223.64 372.85 254.93 381.53 252.35 390.11 221.43 381.34",
    className: "color6f52e7 svgShape"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#aebef9",
    d: "M365.44,335.23h-45.5c-2.8,0-5.07-2.27-5.07-5.07l0,0c0-2.8,2.27-5.07,5.07-5.07h45.5 c2.8,0,5.07,2.27,5.07,5.07l0,0C370.51,332.96,368.24,335.23,365.44,335.23z",
    className: "coloraebef9 svgShape"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#aebef9",
    points: "316.06 426.38 314.53 426.27 322.3 328.4 323.82 328.52",
    className: "coloraebef9 svgShape"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#aebef9",
    points: "370.9 426.39 372.55 426.26 364.73 328.4 363.08 328.53",
    className: "coloraebef9 svgShape"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.58,
    height: 98.12,
    x: 342.47,
    y: 328.33,
    fill: "#aebef9",
    transform: "rotate(-180 343.264 377.392)",
    className: "coloraebef9 svgShape"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 47.04,
    height: 1.44,
    x: 319.95,
    y: 363.43,
    fill: "#aebef9",
    className: "coloraebef9 svgShape"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#46ceff",
    d: "M266.63,419.11c0,0-0.05,8.17,9.45,7.56c9.5-0.61,15.98-2.2,20.63-4.05c4.65-1.85,7.11-3.82,12.26-4.24 c5.15-0.42,10.69,0.83,12.81-2.17c1.74-2.46-1.13-7.93-1.13-7.93l-27.96,4.79L266.63,419.11z",
    className: "color6f52e7 svgShape"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ecc351",
    points: "315.21 392.08 313.54 370.45 289.26 375.9 293.37 397.13 299.94 403.21 311.98 400.5",
    className: "colorecc351 svgShape"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M293.37,397.13c0,0-9.78,9.75-14.79,13.35s-12.41,2.91-11.95,8.63c0.45,5.72,15.65,1.92,24.53-0.41 c8.88-2.33,14.62-6.9,19.58-6.29c4.96,0.61,9.83-2.51,9.91-4.12c0.08-1.62-4.01-15.08-5.43-16.19c0,0-0.67,2.96-9.51,4.67 C296.86,398.47,293.37,397.13,293.37,397.13z",
    className: "color263156 svgShape"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M284.94 410.29l-.12.11c-.23.2-.58.17-.78-.07l-2.17-2.59c-.2-.23-.17-.59.06-.78l.12-.11c.23-.2.58-.17.78.07l2.17 2.59C285.2 409.74 285.17 410.09 284.94 410.29zM287.16 408.08l-.12.11c-.23.2-.58.17-.78-.07l-2.17-2.59c-.2-.23-.17-.59.06-.78l.12-.11c.23-.2.58-.17.78.07l2.17 2.59C287.42 407.53 287.39 407.88 287.16 408.08zM289.78 405.71l-.12.11c-.23.2-.58.17-.78-.07l-2.17-2.59c-.2-.23-.17-.59.06-.78l.12-.11c.23-.2.58-.17.78.07l2.17 2.59C290.04 405.16 290.01 405.51 289.78 405.71zM292.37 403.35l-.12.11c-.23.2-.58.17-.78-.07l-2.17-2.59c-.2-.23-.17-.59.06-.78l.12-.11c.23-.2.58-.17.78.07l2.17 2.59C292.63 402.8 292.6 403.15 292.37 403.35z",
    className: "colorfff svgShape"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M380.73,279.34c0,0,7,43.98-18.49,46.98c-25.49,3-52.2-1.18-52.2-1.18s1.62,6.14,5.08,59.99l-31.38,4.52 c0,0-5.71-22.32-9.96-45.34c-6.2-33.58-6.06-44.75,5.43-54.25s47.62-13.57,47.62-13.57L380.73,279.34z",
    className: "color263156 svgShape"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#aebef9",
    d: "M270.51,324.2c-0.1,0-0.18-0.07-0.19-0.17c-2.24-18.5-0.11-26.79,8.77-34.12c0.08-0.07,0.21-0.06,0.28,0.03 c0.07,0.08,0.06,0.21-0.03,0.28c-8.75,7.23-10.85,15.44-8.63,33.77c0.01,0.11-0.06,0.21-0.17,0.22 C270.52,324.2,270.51,324.2,270.51,324.2z",
    className: "coloraebef9 svgShape"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc351",
    d: "M360.55,174.85c-0.04-0.34,1.03-25.52,1.01-25.84c0,0-1.65-0.11-1.65-0.11 c-6.32,2.7-13.91,7.04-20.25,9.75c0,0.01-1.07,13.64-1.07,13.64s-7.9,6.38-7.94,7.78 C330.53,184.96,355.94,199.29,360.55,174.85z",
    className: "colorecc351 svgShape"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc351",
    d: "M329.85,146.52c0.58,10.85,2.97,22.05,13.36,22.23c7.26,0.13,15.78-8.51,18.86-17.25 c1.59-4.51,3.02-8.44,3.53-11.49c0.4-2.42,0.55-3.95,0.55-3.95l-0.84-5.55l-0.5-3.25c0,0-1.96-2.24-4.14-4.74 c-2.73-3.15-8.25-0.23-8.31-0.42c-0.08-0.3-13.96-4.73-19.41,0.19c-0.02,0.01-0.03,0.02-0.03,0.03 c-0.5,0.45-0.9,0.92-1.19,1.43c-0.24,0.42-0.4,0.86-0.48,1.31c-0.15,0.88-0.34,2.2-0.57,3.87c-0.08,0.7-0.19,1.46-0.27,2.28 c-0.15,1.37-0.3,2.87-0.41,4.47C329.75,139.02,329.65,142.77,329.85,146.52z",
    className: "colorecc351 svgShape"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M337.31,158.54c0,0,4.45-2.12,7.33,0.41L337.31,158.54z",
    className: "colorfff svgShape"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M343.38 168.92c-.06 0-.11 0-.17 0-1.22-.02-2.37-.2-3.42-.52-.09-.03-.14-.12-.11-.21.03-.09.12-.14.21-.11 1.02.31 2.14.48 3.32.5 3.96.07 8.58-2.51 12.65-7.08.06-.07.16-.07.23-.01.07.06.07.16.01.23C352.03 166.31 347.4 168.92 343.38 168.92zM366.09 139.99c0 0 5.64-22.59-7.69-24.89 0 0-11.46-10.22-22.94-2.97-5.51 3.48-6.37 13.61-6.16 16.9.13 2.06.65 3.85.93 3.79.78-.17 1.2-2.14 3.77-1.07 10.42 4.36 20.72-2.96 23.44-.67 2.73 2.29 4.24 21.67 4.24 21.67S363.59 144.38 366.09 139.99z",
    className: "color263156 svgShape"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M330.02,132.62c1.02,2.57,3.78,5.5,11.36,1.94c11.73-5.51,18.54-0.83,18.5-3.59 c-0.04-2.76-6.86-4.9-15.24-4.78S329.04,130.16,330.02,132.62z",
    className: "color263156 svgShape"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc351",
    d: "M362.41,141.53c0,0,6.75-3.28,5.75,2.98c-1,6.26-7.31,8.23-7.31,8.23L362.41,141.53z",
    className: "colorecc351 svgShape"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M363.68,143.75c0,0,5.08-0.86-0.71,5.27L363.68,143.75z",
    className: "color263156 svgShape"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.88,
    cy: 144.68,
    fill: "#263156",
    rx: 1,
    ry: 1.72,
    transform: "rotate(-6.227 335.902 144.72)",
    className: "color263156 svgShape"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 347.73,
    cy: 144.78,
    fill: "#263156",
    rx: 1,
    ry: 1.72,
    transform: "rotate(-6.227 347.755 144.817)",
    className: "color263156 svgShape"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M337.36 139.23c0 0-2.66-2.46-5.27-1.41L337.36 139.23zM352.35 139.03c-.23-.05-3.85-1.09-6.31 1.05L352.35 139.03zM340.94 152.73c-1.1 0-1.47-.5-1.59-.84-.29-.84.38-1.95 1.15-2.35 1.19-.61.84-3.33.83-3.36-.01-.09.05-.17.14-.19.09-.01.17.05.19.14.02.12.39 2.97-1.01 3.7-.7.36-1.2 1.34-.99 1.95.2.58.99.76 2.23.52.09-.02.18.04.19.13.02.09-.04.18-.13.19C341.56 152.7 341.23 152.73 340.94 152.73z",
    className: "color263156 svgShape"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#de5469",
    d: "M312.63,246.78c0,0,10.23,16.62-2.84,18.61c-4.77,0.73-16.06-17.19-16.06-17.19l12.5-8.1L312.63,246.78z",
    className: "colorde5469 svgShape"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc351",
    d: "M314.3,135.96c0,0-19.78,17.51-32.51,38.33c-9.87,16.13-10.87,27.59-8.42,32.86 c1.85,3.97,13.77,4.11,27.45,1.75c9.11-1.57,19.03-4.48,19.03-4.48l0.17-27.56l-20.85,7.6c0,0,7.55-12.02,10.89-17.36 c6.16-9.86,12.15-22.52,12.15-22.52L314.3,135.96z",
    className: "colorecc351 svgShape"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#46ceff",
    d: "M390.37,183.45c-9.69,18.44-11.36,63.56-8.99,95.73c-21.28,5.03-51.93,0.39-70.05-4.62 c2.62-34.36-1.54-68.25,8.44-98.69c0,0,11.37-3.28,18.83-3.58c-6.29,8.53,17.29,10.84,22.27,0 C360.87,172.29,384.9,177.29,390.37,183.45z",
    className: "color6f52e7 svgShape"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#46ceff",
    d: "M319.77,175.87l-16.62,7.04c0,0-0.96,16.29,1.92,25.47l13.69-3.29L319.77,175.87z",
    className: "color6f52e7 svgShape"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M345.34,181.7c-4.82,0-8.65-1.42-9.83-3.69c-0.73-1.41-0.43-3.09,0.88-4.87c0.05-0.07,0.16-0.09,0.23-0.03 c0.07,0.05,0.09,0.16,0.03,0.23c-1.25,1.69-1.53,3.21-0.85,4.52c1.17,2.25,5.15,3.63,10.14,3.51c5.72-0.14,13.4-2.47,16.21-8.56 c0.04-0.08,0.14-0.12,0.22-0.08c0.08,0.04,0.12,0.14,0.08,0.22c-2.87,6.23-10.68,8.61-16.5,8.75 C345.75,181.7,345.54,181.7,345.34,181.7z",
    className: "color263156 svgShape"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc351",
    d: "M402,257.25c-2.35,13.91-41.26,21.18-51.09,22.15l0.37-14.17c18.76-8.86,18.74-11.51,29.12-15.53 l-1.92-30.21c2.43,0.41,12.18,0.55,22.04-4.86C403.87,232.53,403.66,247.42,402,257.25z",
    className: "colorecc351 svgShape"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecc351",
    d: "M336.32,280.04c1.46-0.95,3.22-1.33,9.23-0.46c3.62,0.53,9.41-0.8,10.99-1.15l-0.58-11.15 c-2.34-0.61-6.14-3.12-8.97-4.45c-3.55-1.67-7.45-4.53-10.44-3.52c-5.07,1.72-11.1,4.71-10.35,6.61 c0.77,1.9,6.74,0.03,6.74,0.03s-3.07,1.68-2.68,3.74c0.39,2.05,3.09,2.72,3.09,2.72c-1.46,2.13,1.17,4.1,1.17,4.1 C333.31,278.44,335.16,280.79,336.32,280.04z",
    className: "colorecc351 svgShape"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M334.52 276.7c-.05 0-.1-.02-.13-.06-.06-.07-.05-.18.02-.25.09-.08 2.27-1.86 5.68-2.07.1-.01.18.07.19.16.01.1-.07.18-.16.19-3.29.21-5.45 1.97-5.47 1.99C334.6 276.68 334.56 276.7 334.52 276.7zM333.36 272.59c-.05 0-.1-.02-.13-.06-.06-.07-.06-.18.02-.25.11-.1 2.84-2.48 6.06-3.01.09-.01.18.05.2.14.02.1-.05.18-.14.2-3.12.51-5.86 2.9-5.88 2.92C333.44 272.57 333.4 272.59 333.36 272.59zM332.95 266.13c-.06 0-.12-.03-.15-.09-.05-.08-.02-.19.07-.24.03-.02 2.84-1.57 6.19-1.57.02 0 .04 0 .05 0 .1 0 .17.08.17.18 0 .1-.08.17-.17.17-.02 0-.04 0-.05 0-3.26 0-5.99 1.51-6.02 1.53C333.01 266.13 332.98 266.13 332.95 266.13z",
    className: "color263156 svgShape"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#46ceff",
    d: "M390.37,183.45c0,0,7.53,6.94,11.78,34.07c0,0-16.11,6.88-24.23,4.29l-1.43-20.35L390.37,183.45z",
    className: "color6f52e7 svgShape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ecc351",
    d: "M291.04,234.33c0,0-3.5,0.54-3.78,2.3c-0.28,1.76,1.16,2.34,0.35,3.15c-0.81,0.82-1.51,2.66-0.34,3.69 c1.17,1.03,1.19,1.63,1.14,2.38c-0.06,0.75,0.2,1.73,1.68,2.02c0,0,0.49,3.6,3,3c2.51-0.6,6.12-2.24,7.32-3.13 s2.56-3.35,1.02-3.74c0,0,2.54-1.55,1.64-2.99c0,0,1.66-0.83,1.35-1.98c-0.31-1.15-1.94-1.67-1.94-1.67s1.09-0.82,0.35-2.51 s-5.21-0.65-6.57-0.62C294.89,234.26,293.26,233.65,291.04,234.33z",
    className: "colorecc351 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M290.06 239.58c-.07 0-.13-.04-.15-.11-.03-.08.01-.18.09-.21.09-.04 2.26-.87 3.02-1.07.43-.11 1.06-.11 1.93-.11.7 0 1.56 0 2.6-.06 2.26-.13 4.85-.81 4.87-.82.09-.02.18.03.2.12.02.09-.03.18-.12.2-.03.01-2.64.7-4.94.83-1.05.06-1.92.06-2.62.06-.84 0-1.45 0-1.85.1-.74.19-2.96 1.04-2.98 1.05C290.1 239.58 290.08 239.58 290.06 239.58zM290.15 243.82c-.08 0-.16-.07-.16-.15-.01-.09.06-.17.15-.18.08-.01 1.85-.15 2.71-.13.42.01 1.24-.24 2.1-.51.81-.25 1.65-.51 2.37-.62 1.47-.23 5.64-1.36 5.68-1.37.09-.02.18.03.2.12.02.09-.03.18-.12.2-.17.05-4.22 1.14-5.71 1.38-.69.11-1.52.36-2.33.61-.93.29-1.73.53-2.21.52-.84-.02-2.66.13-2.67.13C290.16 243.82 290.16 243.82 290.15 243.82zM291.58 247.96c-.3 0-.47-.02-.49-.02-.09-.01-.16-.09-.15-.18.01-.09.09-.16.18-.15.01 0 1.05.1 2.7-.22 1.65-.32 7.45-3.5 7.51-3.54.08-.04.18-.01.22.07.04.08.01.18-.07.22-.24.13-5.91 3.24-7.61 3.57C292.85 247.92 292.05 247.96 291.58 247.96z",
    className: "color263156 svgShape"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M378.33,222.25c-0.08,0-0.16-0.06-0.16-0.15l-1.85-20.63c-0.01-0.09,0.06-0.17,0.15-0.18 c0.09-0.01,0.17,0.06,0.18,0.15l1.85,20.63c0.01,0.09-0.06,0.17-0.15,0.18C378.34,222.25,378.33,222.25,378.33,222.25z",
    className: "color263156 svgShape"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d6e0fa",
    d: "M355.51,284.35h-49.38v-4.01H352c1.94,0,3.51,1.57,3.51,3.51V284.35z",
    className: "colord6e0fa svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d6e0fa",
    d: "M252.04,284.35h80.37l-7.97-51.11c-0.2-1.3-1.32-2.25-2.63-2.25h-77.25c-1.64,0-2.89,1.46-2.63,3.08 l7.49,48.03C249.61,283.39,250.73,284.35,252.04,284.35z",
    className: "colord6e0fa svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aebef9",
    d: "M252.04,284.35h73.99c1.64,0,2.89-1.46,2.63-3.08l-7.49-48.03c-0.2-1.3-1.32-2.25-2.63-2.25h-73.99 c-1.64,0-2.89,1.46-2.63,3.08l7.49,48.03C249.61,283.39,250.73,284.35,252.04,284.35z",
    className: "coloraebef9 svgShape"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.69,
    cy: 259.78,
    fill: "#ffffff",
    rx: 5.78,
    ry: 6.27,
    transform: "rotate(-10.376 285.735 259.82)",
    className: "colorfff svgShape"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#46ceff",
    d: "M281.74,382.45l33.23-6.23l0.42,9.41c0,0-31.61,6.32-31.61,5.35S281.74,382.45,281.74,382.45z",
    className: "color6f52e7 svgShape"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ecc351",
    d: "M314.3,135.96c0,0,2.75-8.92,6.22-12.87c1.69-1.92,5.7-4.37,8.1-6.28s3.18-3.87,13.84,0.78 c0,0,0.3,2.83-3.62,2.26c-3.92-0.57-6.28-0.87-7.72,0.33c0,0,3.04-0.74,5.14,0.46c2.1,1.2,2.84,2.1,4.73,3.25 c1.89,1.15,4.02,2.95,2.59,3.75c-1.43,0.8-3.58,0.06-6.03-1.37s-3.64-1.88-4.33-1.83s-4.18,1.48-4.18,1.48s4.17-0.83,6.65,0.54 s6.85,4.3,6.85,4.3s-1.37,2.49-5.12,1.03c-3.75-1.46-4.02-1.8-4.46-1.75s-6.06,1.58-6.06,1.58s4.21-0.14,4.91,0.31 c0.69,0.45,2.95,3.32,5.43,4.7c0,0-1.66,2.3-4.54,0.26c-2.88-2.04-6.62-0.63-6.62-0.63s-0.35,1.74-0.8,4.08s-1.33,4.23-3.52,4.29 L314.3,135.96z",
    className: "colorecc351 svgShape"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M382.42,219.15c-2.85,0-4.36-0.53-4.43-0.55c-0.09-0.03-0.13-0.13-0.1-0.21c0.03-0.09,0.12-0.13,0.21-0.1 c0.08,0.03,7.81,2.66,21.33-4.2c0.08-0.04,0.18-0.01,0.22,0.07s0.01,0.18-0.07,0.22c-7.13,3.62-12.62,4.58-15.96,4.74 C383.2,219.14,382.8,219.15,382.42,219.15z",
    className: "color263156 svgShape"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M313.66,206.49c0,0-0.01,0-0.01,0c-0.09-0.01-0.16-0.09-0.15-0.18c0.01-0.07,0.53-7.16,1.75-11.84 c0.02-0.09,0.11-0.14,0.2-0.12c0.09,0.02,0.14,0.11,0.12,0.2c-1.21,4.65-1.74,11.71-1.74,11.78 C313.81,206.42,313.74,206.49,313.66,206.49z",
    className: "color263156 svgShape"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M307.49,205.67c-0.08,0-0.15-0.05-0.16-0.13c-2.24-11.59-1.86-21.61-1.85-21.71c0-0.09,0.08-0.16,0.17-0.16 c0.09,0,0.16,0.08,0.16,0.17c0,0.1-0.38,10.08,1.85,21.63c0.02,0.09-0.04,0.18-0.13,0.19 C307.52,205.67,307.51,205.67,307.49,205.67z",
    className: "color263156 svgShape"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#263156",
    d: "M291.68,197.97c-0.04,0-0.08-0.01-0.11-0.04c-0.07-0.06-0.08-0.16-0.01-0.23 c2.22-2.52,7.42-13.21,7.47-13.31c0.04-0.08,0.14-0.12,0.22-0.08c0.08,0.04,0.12,0.14,0.08,0.22 c-0.21,0.44-5.27,10.83-7.52,13.39C291.77,197.95,291.73,197.97,291.68,197.97z",
    className: "color263156 svgShape"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 372.69,
    height: 2.3,
    x: 50.81,
    y: 424.16,
    fill: "#263156",
    className: "color263156 svgShape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.41c7d7fd65c2a0df268b04bdc06d6a27.svg";
export { ForwardRef as ReactComponent };